require('aws-sdk/lib/node_loader');
module.exports = {
  ErmineServerSideRenderingService: require('./ermineserversiderenderingservice')
};